import type { EmploymentStatus, EmploymentType } from "../types";

type Props = {
  status?: EmploymentStatus | null;
  employmentStatus?: EmploymentStatus | null;
  employmentType?: EmploymentType | null;
};

export function EmployeeStatusBadge({
  status,
  employmentStatus,
  employmentType,
}: Props) {
  const finalStatus = status ?? employmentStatus;

  const statusStyles: Record<string, string> = {
    ACTIVE: "bg-emerald-100 text-emerald-700",
    ON_PROBATION: "bg-amber-100 text-amber-700",
    ON_LEAVE: "bg-blue-100 text-blue-700",
    SUSPENDED: "bg-red-100 text-red-700",
    TERMINATED: "bg-slate-200 text-slate-600",
    RESIGNED: "bg-purple-100 text-purple-700",
  };

  const typeStyles: Record<string, string> = {
    PERMANENT: "bg-slate-100 text-slate-600",
    CONTRACT: "bg-orange-50 text-orange-700",
    INTERN: "bg-cyan-50 text-cyan-700",
    TEMPORARY: "bg-yellow-50 text-yellow-700",
    CONSULTANT: "bg-violet-50 text-violet-700",
    CASUAL: "bg-pink-50 text-pink-700",
    OTHER: "bg-slate-100 text-slate-500",
  };

  const label = (val: string) =>
    val.replaceAll("_", " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className="flex flex-wrap gap-1.5">
      {finalStatus ? (
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${statusStyles[finalStatus] ?? "bg-slate-100 text-slate-600"}`}>
          {label(finalStatus)}
        </span>
      ) : (
        <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-400">
          Unknown
        </span>
      )}
      {employmentType ? (
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${typeStyles[employmentType] ?? "bg-slate-100 text-slate-600"}`}>
          {label(employmentType)}
        </span>
      ) : null}
    </div>
  );
}